export const MiniQ2AdvancedValuesModel = {
    protocol: "MQTT",
    ip: "-1",
    port: "-1",
    user: "-1",
    pass: "-1",
    type_topic: "",
    topic: "-1",
}
export const MiniQ2HasAdvancedModel = {
    has_ip: false,
    has_port: false,
    has_user: false,
    has_pass: false,
    has_topic: false,
}